import { UserBonusTableTranslations } from "./user-bonus-table-pt-br";

export const USER_BONUS_TABLE_EN_US: UserBonusTableTranslations = {
	title: "Bonus",
	total: "Total of {{category}}",
	noCategory: "No category",
	columns: {
		total: "Total",
		employee: "Employee",
		client: "Client",
		date: "Date",
		reason: "Reason",
		category: "Category",
		receivedValue: "Received value",
		spentValue: "Value spent in the period",
		spentValueInOtherEvents: "Value spent in another period",
	},
	minimumConsumptionReport: {
		title: "Anticipated consumption",
	},
	filenameBonus: "bonus-granted",
	filenameAnticipated: "anticipated-consumption",
	filenameConsumption: "consumption",
	filterCategoryPlaceholder: "Select a category",
	filterEmployeePlaceholder: "Filter by employee",
	categoryNotFound: "No category found",
	exportToExcelButton: "Export to Excel",
};
